import { render, staticRenderFns } from "./LbDemandList.vue?vue&type=template&id=7a4d07c3"
import script from "./LbDemandList.vue?vue&type=script&lang=js"
export * from "./LbDemandList.vue?vue&type=script&lang=js"
import style0 from "./LbDemandList.vue?vue&type=style&index=0&id=7a4d07c3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports